import { useContext, useEffect, useState } from 'react';
import { emailIcon, loginBgIcon, passwordIcon, rightArrowIcon, selfixBigLogoIcon, selfixLogoIcon, successIcon, videoCameraIcon } from '../../assets';
import { RadioButton } from '../../components/RadioButton';
import { TextInput } from '../../components/TextInput';
import './index.css';
import StaticModal from '../../components/StaticModal';
import { useNavigate } from 'react-router';
import AuthStore from '../../stores/AuthStore';
import strings from '../../localization';
import { SelffixLoadingContext } from '../../contexts/SelffixLoadingContext';
import { ModalAlertContext } from '../../contexts/ModalAlertContext';


const RequestPermissions = () => {

  const { showModalAlert, closeModalAlert } = useContext(ModalAlertContext);
  const navigate = useNavigate();

  const requestPermissions = async () => {
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then((stream) => {
        closeModalAlert();
        navigate('/tech/dashboard');
        AuthStore.initializeAuth();
      })
      .catch((error) => {
        console.error("Kullanıcı izin vermedi veya başka bir hata oluştu:", error);
        showModalAlert({
          title: strings.error,
          message: strings.yourDeviceMustHaveAudioAndCameraPermissionsTurnedOn,
          confirmText: strings.ok,
          type: "error",
          onConfirm: () => {
            requestPermissions();
          },
          onCancel: null
        });
      });
  }

  useEffect(() => {
    requestPermissions();
  }, []);
  return (
    <div className='tech-login-container-inner' ><StaticModal
      type="success"
      icon={videoCameraIcon}
      title={strings.loginSuccessfulInitialisingCamera}
      message={strings.yourDeviceMustHaveAudioAndCameraPermissionsTurnedOn}
    >
      <span className='tech-login-container-inner-modal-text'>{strings.pleaseWaitUppercase}</span>
    </StaticModal></div>
  );
};

export const TechLogin = () => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const { showSelffixLoading, closeSelffixLoading } = useContext(SelffixLoadingContext);
  const { showModalAlert, closeModalAlert } = useContext(ModalAlertContext);


  const handleLogin = () => {
    showSelffixLoading()
    if (email === '' || password === '') {
      setEmailError(strings.checkYourEmail);
      setPasswordError(strings.checkYourPassword);
      closeSelffixLoading();
    } else {
      AuthStore.login(email, password, rememberMe).then((response) => {
        if (response.success) {
          if (rememberMe) {
            localStorage.setItem('email', email);
          }
          closeSelffixLoading();
          setIsLoading(true);
        } else {
          closeSelffixLoading();
          setEmailError(response.message);
          setPasswordError(response.message);
        }
      });
    }
  }

  const handleForgotPassword = () => {
    showModalAlert({
      title: strings.comingSoon,
      message: strings.forgotPasswordMessage,
      confirmText: strings.ok,
      onCancel: null,
      onConfirm: () => {
        closeModalAlert();
      }
    });
  }


  useEffect(() => {
    const email = localStorage.getItem('email');
    if (email) {
      setEmail(email);
    }
  }, []);

  return (
    <div className="tech-login">
      <img src={loginBgIcon} alt="login-bg" className="tech-login-bg" />
      <div className="tech-login-gradient" />

      <div className="tech-login-container">
        <div className="tech-login-container-header">
          <img src={selfixBigLogoIcon} alt="logo" className="tech-login-container-header-logo" />
          <span className="tech-login-container-header-title">
            {strings.remoteSupportPlatform}
          </span>
        </div>

        {!isLoading && <div className="tech-login-container-inner">
          <span className="tech-login-container-inner-title">
            {strings.logIn}
          </span>

          <p className="tech-login-container-inner-description">
            {strings.logInWithYourEmailAndPasswordAndYouCanStartTheVideoCallByTypingTheCustomersPhoneNumber}
          </p>

          <div className="tech-login-container-inner-form">
            <TextInput
              label={strings.email}
              leftIcon={emailIcon}
              placeholder={strings.enterYourEmail}
              type="email"
              error={emailError}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onEnter={handleLogin}
            />
            <TextInput
              label={strings.password}
              leftIcon={passwordIcon}
              placeholder={strings.enterYourPassword}
              type="password"
              error={passwordError}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onEnter={handleLogin}
            />
            <RadioButton label={strings.rememberMe} value={rememberMe} onClick={setRememberMe} />
          </div>

          <div className="tech-login-container-inner-form-actions">
            <button className="button-cta-secondary tech-login-container-inner-form-actions-login-btn" onClick={handleLogin} >
              <img src={rightArrowIcon} alt="right-arrow" />
              <span>{strings.logInUppercase}</span>
            </button>
            <button className="button-text-cta button-text-cta-small" onClick={handleForgotPassword} >
              <span>{strings.forgotPassword}</span>
            </button>
          </div>
        </div>}

        {isLoading && <RequestPermissions />}

        <img src={selfixLogoIcon} alt="login-bg" className="tech-login-container-inner-logo" style={{ marginTop: !isLoading ? '-20px' : '0px' }} />

      </div>
    </div>
  );
};